import { Avatar, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { motion } from "framer-motion";
import { TableData, TableDataProps } from "../TableData";

export const BeroepsI1a1April17 = (props: TableDataProps) => {
  return (
    <>
      <TableData data={props.data} />

      <Box
        component={motion.div}
        animate={{
          scale: [1, 1.05, 1],
          rotate: [-5, 5],
          transition: {
            duration: 3,
            ease: "easeInOut",
            repeat: Infinity,
            repeatType: "reverse",
          },
        }}
        sx={{
          position: "absolute",
          top: 15,
          right: 25,
          zIndex: 100,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar src="./teachers/ims.jpg" sx={{ width: 100, height: 100 }} />
        <Typography variant="h5" sx={{ color: "var(--body)" }}>
          ⭐️ Special Guest: Mr. Moslèh 👏
        </Typography>
      </Box>
    </>
  );
};
